export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'input',
    parse: 'input',
  },
  display: {
    dateInput: 'input',
    monthYearLabel: 'header',
    dateA11yLabel: 'input',
    monthYearA11yLabel: 'header',
  },
};

export const DIALOG_DATE_FORMATS = {
  parse: {
    dateInput: 'input-short',
    parse: 'input-short',
  },
  display: {
    dateInput: 'input-short',
    monthYearLabel: 'header',
    dateA11yLabel: 'input-short',
    monthYearA11yLabel: 'header',
  },
};
